import withProps from 'recompose/withProps';
import { CityLandingPages } from 'components/landing/CityLandingPages';

export const enhance = withProps({
	headline: 'Cities with Portable Storage',
	cities: [
		{
			name: 'Alexandria',
			url: '/portable-storage/alexandria-va.html'
		},
		{
			name: 'Anaheim',
			url: '/portable-storage/anaheim-ca.html'
		},
		{
			name: 'Arlington',
			url: '/portable-storage/arlington-va.html'
		},
		{
			name: 'Atlanta',
			url: '/portable-storage/atlanta-ga.html'
		},
		{
			name: 'Aurora',
			url: '/portable-storage/aurora-co.html'
		},
		{
			name: 'Austin',
			url: '/portable-storage/austin-tx.html'
		},
		{
			name: 'Baton Rouge',

			url: '/portable-storage/baton-rouge-la.html'
		},
		{
			name: 'Boston',
			url: '/portable-storage/boston-ma.html'
		},
		{
			name: 'Boulder',
			url: '/portable-storage/boulder-co.html'
		},
		{
			name: 'Bronx',
			url: '/portable-storage/bronx-ny.html'
		},
		{
			name: 'Brooklyn',
			url: '/portable-storage/brooklyn-ny.html'
		},
		{
			name: 'Buffalo',
			url: '/portable-storage/buffalo-ny.html'
		},
		{
			name: 'Chandler',
			url: '/portable-storage/chandler-az.html'
		},
		{
			name: 'Charlotte',
			url: '/portable-storage/charlotte-nc.html'
		},
		{
			name: 'Chattanooga',

			url: '/portable-storage/chattanooga-tn.html'
		},
		{
			name: 'Chicago',
			url: '/portable-storage/chicago-il.html'
		},
		{
			name: 'Chula Vista',

			url: '/portable-storage/chula-vista-ca.html'
		},
		{
			name: 'Clearwater',
			url: '/portable-storage/clearwater-fl.html'
		},
		{
			name: 'Cleveland',
			url: '/portable-storage/cleveland-oh.html'
		},
		{
			name: 'College Station',

			url: '/portable-storage/college-station-tx.html'
		},
		{
			name: 'Colorado Springs',

			url: '/portable-storage/colorado-springs-co.html'
		},
		{
			name: 'Columbus',
			url: '/portable-storage/columbus-oh.html'
		},
		{
			name: 'Concord',
			url: '/portable-storage/concord-ca.html'
		},
		{
			name: 'Corpus Christi',

			url: '/portable-storage/corpus-christi-tx.html'
		},
		{
			name: 'Costa Mesa',
			url: '/portable-storage/costa-mesa-ca.html'
		},
		{
			name: 'Dallas',
			url: '/portable-storage/dallas-tx.html'
		},
		{
			name: 'Denver',
			url: '/portable-storage/denver-co.html'
		},
		{
			name: 'Detroit',
			url: '/portable-storage/detroit-mi.html'
		},
		{
			name: 'Durham',
			url: '/portable-storage/durham-nc.html'
		},
		{
			name: 'Edison',
			url: '/portable-storage/edison-nj.html'
		},
		{
			name: 'El Cajon',
			url: '/portable-storage/el-cajon-ca.html'
		},
		{
			name: 'El Paso',
			url: '/portable-storage/el-paso-tx.html'
		},
		{
			name: 'Escondido',
			url: '/portable-storage/escondido-ca.html'
		},
		{
			name: 'Fairfax',
			url: '/portable-storage/fairfax-va.html'
		},
		{
			name: 'Fayetteville',

			url: '/portable-storage/fayetteville-nc.html'
		},
		{
			name: 'Fort Lauderdale',

			url: '/portable-storage/fort-lauderdale-fl.html'
		},
		{
			name: 'Fort Myers',
			url: '/portable-storage/fort-myers-fl.html'
		},
		{
			name: 'Fort Worth',
			url: '/portable-storage/fort-worth-tx.html'
		},
		{
			name: 'Fremont',
			url: '/portable-storage/fremont-ca.html'
		},
		{
			name: 'Greensboro',
			url: '/portable-storage/greensboro-nc.html'
		},
		{
			name: 'Hayward',
			url: '/portable-storage/hayward-ca.html'
		},
		{
			name: 'Henderson',
			url: '/portable-storage/henderson-nv.html'
		},
		{
			name: 'Honolulu',
			url: '/portable-storage/honolulu-hi.html'
		},
		{
			name: 'Houston',
			url: '/portable-storage/houston-tx.html'
		},
		{
			name: 'Huntington Beach',

			url: '/portable-storage/huntington-beach-ca.html'
		},
		{
			name: 'Indianapolis',

			url: '/portable-storage/indianapolis-in.html'
		},
		{
			name: 'Jacksonville',

			url: '/portable-storage/jacksonville-fl.html'
		},
		{
			name: 'Jersey City',

			url: '/portable-storage/jersey-city-nj.html'
		},
		{
			name: 'Katy',
			url: '/portable-storage/katy-tx.html'
		},
		{
			name: 'Kissimmee',
			url: '/portable-storage/kissimmee-fl.html'
		},
		{
			name: 'Lakeland',
			url: '/portable-storage/lakeland-fl.html'
		},
		{
			name: 'Las Vegas',
			url: '/portable-storage/las-vegas-nv.html'
		},
		{
			name: 'Long Beach',
			url: '/portable-storage/long-beach-ca.html'
		},
		{
			name: 'Los Angeles',

			url: '/portable-storage/los-angeles-ca.html'
		},
		{
			name: 'Louisville',
			url: '/portable-storage/louisville-ky.html'
		},
		{
			name: 'Mesa',
			url: '/portable-storage/mesa-az.html'
		},
		{
			name: 'Miami',
			url: '/portable-storage/miami-fl.html'
		},
		{
			name: 'Minneapolis',

			url: '/portable-storage/minneapolis-mn.html'
		},
		{
			name: 'Murrieta',
			url: '/portable-storage/murrieta-ca.html'
		},
		{
			name: 'Naples',
			url: '/portable-storage/naples-fl.html'
		},
		{
			name: 'New York',
			url: '/portable-storage/new-york-ny.html'
		},
		{
			name: 'Newark',
			url: '/portable-storage/newark-nj.html'
		},
		{
			name: 'Norfolk',
			url: '/portable-storage/norfolk-va.html'
		},
		{
			name: 'Oakland',
			url: '/portable-storage/oakland-ca.html'
		},
		{
			name: 'Oklahoma City',

			url: '/portable-storage/oklahoma-city-ok.html'
		},
		{
			name: 'Ontario',
			url: '/portable-storage/ontario-ca.html'
		},
		{
			name: 'Orlando',
			url: '/portable-storage/orlando-fl.html'
		},
		{
			name: 'Oxnard',
			url: '/portable-storage/oxnard-ca.html'
		},
		{
			name: 'Pearland',
			url: '/portable-storage/pearland-tx.html'
		},
		{
			name: 'Pensacola',
			url: '/portable-storage/pensacola-fl.html'
		},
		{
			name: 'Philadelphia',

			url: '/portable-storage/philadelphia-pa.html'
		},
		{
			name: 'Phoenix',
			url: '/portable-storage/phoenix-az.html'
		},
		{
			name: 'Pittsburgh',
			url: '/portable-storage/pittsburgh-pa.html'
		},
		{
			name: 'Portland',
			url: '/portable-storage/portland-or.html'
		},
		{
			name: 'Providence',
			url: '/portable-storage/providence-ri.html'
		},
		{
			name: 'Queens',
			url: '/portable-storage/queens-ny.html'
		},
		{
			name: 'Raleigh',
			url: '/portable-storage/raleigh-nc.html'
		},
		{
			name: 'Riverside',
			url: '/portable-storage/riverside-ca.html'
		},
		{
			name: 'Sacramento',
			url: '/portable-storage/sacramento-ca.html'
		},
		{
			name: 'Salt Lake City',

			url: '/portable-storage/salt-lake-city-ut.html'
		},
		{
			name: 'San Antonio',

			url: '/portable-storage/san-antonio-tx.html'
		},
		{
			name: 'San Bernardino',

			url: '/portable-storage/san-bernardino-ca.html'
		},
		{
			name: 'San Diego',
			url: '/portable-storage/san-diego-ca.html'
		},
		{
			name: 'San Francisco',

			url: '/portable-storage/san-francisco-ca.html'
		},
		{
			name: 'San Jose',
			url: '/portable-storage/san-jose-ca.html'
		},
		{
			name: 'Santa Ana',
			url: '/portable-storage/santa-ana-ca.html'
		},
		{
			name: 'Scottsdale',
			url: '/portable-storage/scottsdale-az.html'
		},
		{
			name: 'Seattle',
			url: '/portable-storage/seattle-wa.html'
		},
		{
			name: 'St Louis',
			url: '/portable-storage/st-louis-mo.html'
		},
		{
			name: 'St Petersburg',

			url: '/portable-storage/st-petersburg-fl.html'
		},
		{
			name: 'Tacoma',
			url: '/portable-storage/tacoma-wa.html'
		},
		{
			name: 'Tampa',
			url: '/portable-storage/tampa-fl.html'
		},
		{
			name: 'Temecula',
			url: '/portable-storage/temecula-ca.html'
		},
		{
			name: 'Tempe',
			url: '/portable-storage/tempe-az.html'
		},
		{
			name: 'Tucson',
			url: '/portable-storage/tucson-az.html'
		},
		{
			name: 'Vancouver',
			url: '/portable-storage/vancouver-wa.html'
		},
		{
			name: 'Virginia Beach',

			url: '/portable-storage/virginia-beach-va.html'
		},
		{
			name: 'Washington',
			url: '/portable-storage/washington-dc.html'
		},
		{
			name: 'West Palm Beach',
			url: '/portable-storage/west-palm-beach-fl.html'
		},
		{
			name: 'White Plains',
			url: '/portable-storage/white-plains-ny.html'
		},
		{
			name: 'Worcester',
			url: '/portable-storage/worcester-ma.html'
		}]
});

export default enhance(CityLandingPages);
